import * as React from 'react';
import { connect } from 'react-redux';
import { IBasePageProps } from '../../../../configuration/IConfiguration';
import { bindActionCreators } from 'redux';
import { IAppState } from '../../../../../../app';
import InternalClassificationLink from '../../../../Common/Links/InternalClassificationLink';
import Select from "react-select";
import InternalAbsoluteLink from '../../../../Common/Links/InternalAbsoluteLink';
import { IHiddenFieldOption } from '../../PageGroups';

interface IPagePreRegisterProps {
    seenPlatypusOptions: IHiddenFieldOption[];
}

interface IPagePreRegisterRouteParams {
}

interface IPagePreRegisterQueryParams {
}

type PagePreRegisterProps = IBasePageProps<IPagePreRegisterRouteParams, IPagePreRegisterQueryParams> & IPagePreRegisterProps;

interface IPagePreRegisterState {
    seenPlatypus: IHiddenFieldOption
}

class PagePreRegister extends React.Component<PagePreRegisterProps, IPagePreRegisterState> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            seenPlatypus: undefined
        }

        this.seenPlatypusChange = this.seenPlatypusChange.bind(this);
    }

    seenPlatypusChange(obj) {
        this.setState({
            seenPlatypus: obj
        });
    }

    render() {

        const neverSeenElement = <div>
            <p>Before you can produce useful data it is vital that you are confident with identifying platypus in the wild. The following resources can help you with this:</p>
            <ul>
                <li>Learn more about how to spot a platypus {InternalAbsoluteLink("/spot-a-platypus", "here", undefined, undefined)} </li>
                <li>Get in touch with a mentor on the <a target="_blank" href="https://www.facebook.com/Australian-Platypus-Conservancy-Official-225816770830721/">APMN Facebook Page.</a></li>
            </ul>
            {InternalClassificationLink("user/register", "REGISTER NOW", undefined, "btn btn-outline-primary btn-lg", {hf: this.state.seenPlatypus ? this.state.seenPlatypus.value : -1})}
        </div>;


        return <div className="p-4">
            <h3>Volunteer Registration</h3>
            <div className="col-6">
                <h5>How often have you seen a platypus in the wild?</h5>
                <Select
                    options={this.props.seenPlatypusOptions}
                    onChange={this.seenPlatypusChange}
                    value={this.state.seenPlatypus}
                />
                
                {this.state.seenPlatypus ? this.state.seenPlatypus.value < 2
                    ? neverSeenElement
                    : InternalClassificationLink("user/register", "REGISTER NOW", undefined, "btn btn-primary btn-lg mt-4", {hf: this.state.seenPlatypus ? this.state.seenPlatypus.value : -1})
                    : undefined}
            </div>
        </div>
    };
}

const mapStateToProps = (state: IAppState, ownProps: PagePreRegisterProps) => {

    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PagePreRegister);